import { render, staticRenderFns } from "./RequestButtonKanbanBoard.vue?vue&type=template&id=cb827342&scoped=true"
import script from "@/components/request/RequestButtonKanbanBoard/RequestButtonKanbanBoard.ts?vue&type=script&lang=ts&external"
export * from "@/components/request/RequestButtonKanbanBoard/RequestButtonKanbanBoard.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/request/RequestButtonKanbanBoard/request-button-kanban-board.scss?vue&type=style&index=0&id=cb827342&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb827342",
  null
  
)

export default component.exports